import { GET_CUSTOMER_FLAGS, GET_CUSTOMER_FLAG, UPDATE_CUSTOMER_FLAGS, DELETE_CUSTOMER_FLAGS, GET_CUSTOMER_FLAGS_BY_IDS } from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    customerFlags: {},
    currentCustomerFlag: {}
};

// REDUCER
export const CustomerFlagReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CUSTOMER_FLAGS: {
            const incomingCustomerFlags = action.payload.customerFlags
            const customerFlags = {}

            incomingCustomerFlags.forEach(flag => {
                customerFlags[flag.id] = flag
            });


            return {
                ...state,
                customerFlags
            }
        }

        case GET_CUSTOMER_FLAG: {
            const currentCustomerFlag = action.payload

            return {
                ...state,
                currentCustomerFlag
            }
        }

        case GET_CUSTOMER_FLAGS_BY_IDS: {
            const incomingCustomerFlags = action.payload
            const customerFlags = {}

            incomingCustomerFlags.forEach(flag => {
                customerFlags[flag.id] = flag
            });


            return {
                ...state,
                customerFlags
            }
        }

        case UPDATE_CUSTOMER_FLAGS: {
            return {
                ...state,
            }
        }

        case DELETE_CUSTOMER_FLAGS: {
            return {
                ...state,
            }
        }

        default:
            return state;
    }
};